import { Action } from '@ngrx/store';

export class AveragePriceAction implements Action {

    public static getCustodyAveragePrice = '[Average Price] get_custody_average_price';
    public static getCustodyAveragePriceError = '[Average Price] get_custody_average_price_error';
    public static getCustodyAveragePriceSuccess = '[Average Price] get_custody_average_price_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
